import { useSelector } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import {
  getLineColorFunctionMapping,
  getLineWidthFunctionMapping,
  getFillColorFunctionMapping,
  getPointRadiusFunctionMapping,
} from 'components/contexts/LayerStyleReferenceMapping';
import { useAppState } from 'components/contexts/State';
import {
  getFormattedValue,
  getNameFormatterFromColumn,
  getValueFormatterFromColumn,
} from 'components/contexts/ColumnFormatterMapping';

export const CUSTOMSQL_THIRD_LAYER_ID = 'customSqlThirdLayer';

function CustomSqlThirdLayer() {
  const { customSqlThirdLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, customSqlThirdLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  const { customSqlData } = useAppState();

  if (customSqlThirdLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: CUSTOMSQL_THIRD_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: customSqlThirdLayer.visible,
      opacity: customSqlThirdLayer.opacity,

      getFillColor: getFillColorFunctionMapping[customSqlThirdLayer.getFillColor]
        ? getFillColorFunctionMapping[customSqlThirdLayer.getFillColor]
        : [0, 0, 0],
      pointRadiusMinPixels: customSqlThirdLayer.pointRadiusMinPixels
        ? customSqlThirdLayer.pointRadiusMinPixels
        : 1,
      getPointRadius: (v) => {
        if (
          customSqlThirdLayer.getFillColor === 'default_point' ||
          customSqlThirdLayer.getFillColor === 'secondary_point' ||
          customSqlThirdLayer.getFillColor === 'tertiary_point'
        )
          return getPointRadiusFunctionMapping.default_point(v);
        return 5;
      },

      getLineColor: getLineColorFunctionMapping[customSqlThirdLayer.getLineColor]
        ? getLineColorFunctionMapping[customSqlThirdLayer.getLineColor]
        : [0, 0, 0],
      lineWidthMinPixels: customSqlThirdLayer.lineWidthMinPixels
        ? customSqlThirdLayer.lineWidthMinPixels
        : 1,
      getLineWidth: (v) => {
        if (
          customSqlThirdLayer.getLineColor === 'default_line' ||
          customSqlThirdLayer.getLineColor === 'secondary_line' ||
          customSqlThirdLayer.getLineColor === 'tertiary_line'
        )
          return getLineWidthFunctionMapping.default_line(v);
        return 1;
      },

      pointType: customSqlThirdLayer.pointType ? customSqlThirdLayer.pointType : 'circle',

      onDataLoad: (data) => {
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object && info?.object?.properties) {
          const tooltip = customSqlData[2]?.properties?.tooltip;
          const title = tooltip.title ? tooltip.title : 'Details';
          let subTitle = tooltip.subtitle ? tooltip.subtitle : '';
          let htmlString = '';

          if (tooltip?.columns && tooltip?.columns?.length > 0) {
            if (
              tooltip.subtitle_column &&
              info?.object?.properties[tooltip.subtitle_column]
            ) {
              subTitle = info?.object?.properties[tooltip.subtitle_column];
            }
            htmlString += `<div class="deck-tooltip-title">${title}</div>`;
            if (subTitle) {
              htmlString += `<div class="deck-tooltip-subtitle">${subTitle}</div>`;
            }
            htmlString += `<div class="deck-hr"></div><div class="deck-tooltip-msg-container">`;
            tooltip.columns.forEach((column) => {
              htmlString += `<div class="deck-tooltip-msg-wrapper"><div class="deck-tooltip-msg-text-1">${
                getNameFormatterFromColumn(source?.data, column)
                  ? getNameFormatterFromColumn(source?.data, column)
                  : column.replace(/_/g, ' ')
              }</div><div class="deck-tooltip-msg-text-2">`;
              htmlString += getValueFormatterFromColumn(source?.data, column)
                ? new Function(
                    'return ' + getValueFormatterFromColumn(source?.data, column)
                  )()(info?.object?.properties[column])
                : getFormattedValue(info?.object?.properties[column]);
              htmlString += `</div></div>`;
            });
            htmlString += `</div>`;
          }
          info.object = { html: htmlString };
        }
      },
    });
  }
}

export default CustomSqlThirdLayer;
